exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1s4zB{position:relative;padding:7px 8px;border-radius:2px;height:42px;line-height:30px;border:1px solid #c4c4c4;outline:none;font-size:13px;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}._1s4zB::-webkit-input-placeholder{color:gray}._1s4zB::-moz-placeholder{color:gray}._1s4zB:-ms-input-placeholder{color:gray}._1s4zB::placeholder{color:gray}.vJnum{position:relative;margin:0 auto 10px;width:100%;padding:10px 0;font-size:14px;color:#000;font-weight:700;border-width:1px;border-style:solid;outline:none;cursor:pointer;line-height:1.1;border-radius:3px;white-space:nowrap}.vJnum:disabled,.vJnum:disabled>.hX4eV{color:rgba(0,0,0,.25);pointer-events:none}._1F-aN{color:rgba(0,0,0,.25)}._2YtbV,._3bKRW{background-color:#ffd906;border-color:#ffd906}._2YtbV,._3bKRW:hover{background-color:#ffc107;border-color:#ffc107}._2YtbV{border:none}._2YtbV:disabled{background-color:#f5f5f5}._1AWF-{background-color:#fff;border-color:#c4c4c4}._1AWF-:hover{background-color:#fffceb}._2DyKI{background-color:transparent}._2DyKI:hover,._38ptx:hover{background-color:#ffc10744}._38ptx{background-color:transparent;border:1px solid #ffc107}.vJnum.aO6AT>:not(._289M5){visibility:hidden}._15Egm{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);padding:0;font-size:11px}.zoFvb>svg{margin-left:6px}.vJnum:not(.zoFvb)>svg{margin-right:6px}", ""]);

// exports
exports.locals = {
	"inputGeneral": "_1s4zB",
	"ButtonGeneral": "vJnum",
	"btnInfo": "hX4eV",
	"ButtonDisabledStyle": "_1F-aN",
	"ButtonYellowFlat": "_2YtbV",
	"ButtonYellow": "_3bKRW",
	"ButtonWhite": "_1AWF-",
	"ButtonTransparent": "_2DyKI",
	"ButtonTransparentYellow": "_38ptx",
	"buttonLoader": "aO6AT",
	"ButtonProcessing": "_289M5",
	"ButtonLoader": "_15Egm",
	"iconAfterText": "zoFvb"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/UI/UIStyle.css
// module id = 1309
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46